import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "24x24/heart"
  }, React.createElement("path", {
    id: "Vector (Stroke)",
    d: "M11.3254 22.6176L11.3244 22.6171L11.3218 22.6156L11.3139 22.611L11.2878 22.596C11.266 22.5834 11.2352 22.5654 11.1961 22.5423C11.1179 22.496 11.0064 22.429 10.8663 22.3422C10.5863 22.1686 10.1911 21.9152 9.71907 21.5892C8.77762 20.939 7.51717 19.991 6.25083 18.8029C3.78242 16.487 1 12.9859 1 8.80463C1 5.0393 4.04205 2 7.77855 2C9.37392 2 10.8419 2.55426 12 3.48049C13.1581 2.55426 14.6261 2 16.2215 2C19.9579 2 23 5.0393 23 8.80463C23 12.9859 20.2176 16.487 17.7492 18.8029C16.4828 19.991 15.2224 20.939 14.2809 21.5892C13.8089 21.9152 13.4137 22.1686 13.1337 22.3422C12.9936 22.429 12.8821 22.496 12.8039 22.5423C12.7648 22.5654 12.734 22.5834 12.7122 22.596L12.6861 22.611L12.6782 22.6156L12.6756 22.6171L12.6746 22.6176L12 23L11.3254 22.6176Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Heart24 } from '@cian/ui-kit/icons';`, <br />
 * где 24 - это размер иконки в пикселях.
 */

export var Heart24 = createIcon(IconComponent);